import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import { SectionHeader_2, Card_6 } from '../../../../../component/landingComponent'
const CbQuickToMarket = () => {
    return (
        <div className='row pt-20 px-10 mb-20'>
            <div className='col-md-12 text-center'>
                <SectionHeader_2
                    title= {`Quick to market`}
                />
            </div>
            <div className='row mt-20 border px-10 br-20'>
                <div className='col-md-5 pe-15 m-auto py-10'>
                    <img src="/assets/img/quick.jpg" alt="app image" className="radius-20" style={{}} />
                </div>
                <div className='col-md-7 m-auto'>
                    <div className='mt-6'>
                        <ul className="list-check ">
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                If time and reliability are critical for you, then talk to us. We build the most powerful AI Agents much faster than anyone out there.
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                You will benefit from our deep expertise while saving on staffing, overheads and managing delivery yourself.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export {CbQuickToMarket}